/**
 * Converts between Bing market codes and Hotels currency codes
 */
const getCurrencyForMarket = (market) => {
  switch (market) {
    case 'sv-se':
      return 'SEK';
    case 'fr-ca':
      return 'CAD';
    case 'en-ca':
      return 'CAD';
    case 'en-au':
      return 'AUD';
    case 'en-gb':
      return 'GBP';
    case 'en-ie':
      return 'GBP';
    case 'en-us':
      return 'USD';
    case 'es-us':
      return 'USD';
    case 'en-nz':
      return 'NZD';
    default:
      return 'EUR';
  }
};

module.exports = getCurrencyForMarket;
